module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/subscribe.2fa92ec7ce7da841.png";